import { PaymentService } from '@wix/cashier-core/dist/src/services/Payment';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { AuthParams } from '../../types/AuthParams';

export const EXPRESS_CHECKOUT_TYPE = 'EXPRESS';
export interface PaymentDetailsParamsPayPal {
  orderId: string;
  payerId: string;
  sessionId: string;
}

export interface PaymentDetailsParamsGooglePay {}

/**
 * Create payment details for GooglePay
 */
export const createGooglePayPayment = async (
  paymentData: google.payments.api.PaymentData,
  auth: AuthParams,
  sessionId: string,
): Promise<string> => {
  const { description, tokenizationData, info } = paymentData.paymentMethodData;
  const { detailsId } = await new PaymentService(auth).createPayment({
    details: {
      checkoutSession: sessionId,
      paymentMethod: PaymentMethod.GooglePay,
      checkoutType: EXPRESS_CHECKOUT_TYPE,
      googlePay: {
        token: tokenizationData.token,
        displayName: description,
        network: info.cardNetwork,
        type: tokenizationData.type,
      },
    },
  });
  return detailsId;
};

/**
 * Create payment details for ApplePay
 */
export const createApplePayPayment = async (
  token: ApplePayJS.ApplePayPaymentToken,
  auth: AuthParams,
  sessionId: string,
): Promise<string> => {
  const encryptedToken = encodePaymentToken(token.paymentData);
  const { displayName, network, type } = token.paymentMethod;
  const { detailsId } = await new PaymentService(auth).createPayment({
    details: {
      checkoutSession: sessionId,
      paymentMethod: PaymentMethod.ApplePay,
      checkoutType: EXPRESS_CHECKOUT_TYPE,
      billingAddress: {
        address: '',
      },
      applePay: {
        token: encryptedToken,
        displayName,
        network,
        type,
      },
    },
  });
  return detailsId;
};

/**
 * Creates payment details for PayPal
 */
export const createPayPalPayment = async (data: PaymentDetailsParamsPayPal, auth: AuthParams): Promise<string> => {
  const { detailsId } = await new PaymentService(auth).createPayment({
    details: {
      paymentMethod: PaymentMethod.PayPal, // # ADR: 0001
      token: data.orderId,
      checkoutSession: data.sessionId,
      checkoutType: EXPRESS_CHECKOUT_TYPE,
      additionalData: {
        'payPal.payerId': data.payerId,
      },
    },
  });
  return detailsId;
};

/**
 * Converts paymentData to token that will be used for charge
 * @param paymentData
 */
export const encodePaymentToken = (paymentData) => {
  return btoa(JSON.stringify(paymentData));
};
